module.exports = __webpack_public_path__ + "img/Autofaktura4.8c0dccc6.png";